/** Decorative icon from public/site/icons (Lucide set); meaning always comes from adjacent text. */
export const icon = (name: string) => <img src={`/site/icons/${name}.svg`} alt="" />;
